import JwtDecode from 'jwt-decode';

const tokenKey = 'sartoken';

export function getAdviserId() {
    const validToken = tokenIsValid();
    return validToken ? getDecodedToken().adviserId : null;
}

export function tokenIsValid() {
    const decoded = getDecodedToken();
    const currentDate = Date.now();
    const expiry = decoded ? decoded.exp * 1000 : null;
    const validToken = expiry ? expiry >= currentDate : false;
    return validToken;
}

export function clearToken() {
    localStorage.removeItem(tokenKey);
}

function getDecodedToken() {
    const token = localStorage.getItem(tokenKey);
    const decoded = token ? JwtDecode(token) : null;
    return decoded;
}
